import { Component, Input } from "@angular/core";
import { ISelectedAd } from "../../models/selectedad";

@Component({
  selector: "af-status",
  templateUrl: "status.html",
})
export class StatusComponent {
  @Input()
  public selectedAd: ISelectedAd;
}



// WEBPACK FOOTER //
// ./src/components/status/status.ts